// pipe (Sites admin): the shared server verdict for the current actor's ERP and AI permissions — the
// cached `/me/provisioning` summary (admin tier + facility memberships). BOTH the Sites screen (which
// gates its create/retire/manage affordances) AND its admin-gated sidebar nav read THIS one hook (one
// fetch, one source — SSOT/DRY). It never re-derives admin status client-side; the Core API is the
// authority and re-checks every action. Returns `null` until loaded / on failure (fail-closed — a null
// result must be treated as "no admin", so admin-only UI never flashes for a non-admin).
import { AuthService } from '@affine/core/modules/cloud';
import { useLiveData, useService } from '@toeverything/infra';
import { useEffect } from 'react';

import { ErpService } from './services/erp';

export function useErpProvisioning() {
  const erp = useService(ErpService);
  const account = useLiveData(useService(AuthService).session.account$);
  const userId = account?.id;
  useEffect(() => erp.observeProvisioning(), [erp, userId]);
  const provisioning = useLiveData(erp.provisioning$);
  return userId && provisioning?.userId === userId ? provisioning : null;
}

/** Keep the last verified narrowing during transient authority failures. No role or
 * capability is exposed here; callers must use useErpProvisioning for permissions. */
export function useErpSiteMapping() {
  const erp = useService(ErpService);
  const account = useLiveData(useService(AuthService).session.account$);
  const userId = account?.id;
  useEffect(() => erp.observeProvisioning(), [erp, userId]);
  const mapping = useLiveData(erp.siteMapping$);
  return userId && mapping?.userId === userId ? mapping : null;
}
